export default "__VITE_ASSET__DHSTQxXK__"